import BusSystemApi from './_busSystemApi';

class GettingStartedApi extends BusSystemApi {
  constructor() {
    super();
  }
  apiName = 'Platform';
  controllerName = 'userRoles';

  /**
   * lấy danh sách userRole theo userId
   * @param {*} userId
   * @returns
   */
  getUserRolesByUserIdAsync(userId) {
    let request = {
      url: this.getAPIUrl() + '/by-user',
      params: {
        userId: userId,
      },
    };

    return this.getAsync(request);
  }
}

export default new GettingStartedApi();
